/* One tap upsell: adds the product, then redraws the cart drawer the same way the theme does */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-arri-upsell]');
  if (!btn || btn.disabled) return;
  e.preventDefault();
  e.stopPropagation();
  btn.disabled = true;
  var label = btn.textContent;
  btn.textContent = 'Adding';
  var drawer = document.querySelector('cart-drawer');
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({
      items: [{ id: parseInt(btn.getAttribute('data-arri-upsell'), 10), quantity: 1 }],
      sections: 'cart-drawer,cart-icon-bubble',
      sections_url: window.location.pathname
    })
  }).then(function (r) {
    if (!r.ok) { throw new Error('add failed'); }
    return r.json();
  }).then(function (state) {
    if (drawer && typeof drawer.renderContents === 'function' && state.sections) {
      drawer.renderContents(state);
    } else {
      window.location.reload();
    }
  }).catch(function () {
    btn.disabled = false;
    btn.textContent = label;
    window.location.href = '/cart';
  });
}, true);
